export default "__VITE_ASSET__C_aR1ujE__"